const resultLabels: Record<string, string> = {
  response: 'Executado com resposta',
  no_response: 'Executado sem resposta',
  error: 'Erro técnico — não foi possível executar',
}

function firstName(name: string) {
  return name.trim().split(/\s+/)[0] ?? ''
}

function safeName(name: string) {
  return firstName(name)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9_-]/g, '')
}

export function studentFolderName(name: string) {
  const normalized = safeName(name)
  return normalized ? `RECUPERACAO_${normalized}` : 'RECUPERACAO_SEU_NOME'
}

export function renderStepText(
  text: string,
  fieldValues: Record<string, string>,
) {
  const name = firstName(fieldValues.student_name ?? '') || 'SEU NOME'
  const replacements: Record<string, string> = {
    '{{NOME}}': name,
    '{{PASTA_PRINCIPAL}}': studentFolderName(name),
    '{{LOOPBACK_RESULT}}':
      resultLabels[fieldValues.loopback_result] ??
      'Resultado ainda não registrado',
    '{{GATEWAY_RESULT}}':
      resultLabels[fieldValues.gateway_result] ??
      'Resultado ainda não registrado',
    '{{DNS_RESULT}}':
      resultLabels[fieldValues.dns_result] ??
      'Resultado ainda não registrado',
  }

  return Object.entries(replacements).reduce(
    (rendered, [token, value]) => rendered.replaceAll(token, value),
    text,
  )
}
